import { render, staticRenderFns } from "./MapPolygons.vue?vue&type=template&id=24850a1c&"
import script from "./MapPolygons.vue?vue&type=script&lang=js&"
export * from "./MapPolygons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports